"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IdleLogoutModal = exports.DEFAULT_ACTION_CANCEL = exports.DEFAULT_ACTION_CONFIRM = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ModalAlert = _interopRequireDefault(require("../ModalAlert"));

var _CountDown = _interopRequireDefault(require("./CountDown"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DEFAULT_ACTION_CONFIRM = 'confirm';
exports.DEFAULT_ACTION_CONFIRM = DEFAULT_ACTION_CONFIRM;
var DEFAULT_ACTION_CANCEL = 'cancel';
exports.DEFAULT_ACTION_CANCEL = DEFAULT_ACTION_CANCEL;

var IdleLogoutModal = function IdleLogoutModal(_ref) {
  var isIdle = _ref.isIdle,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 1000 * 60 * 2 : _ref$timeout,
      _ref$defaultAction = _ref.defaultAction,
      defaultAction = _ref$defaultAction === void 0 ? DEFAULT_ACTION_CONFIRM : _ref$defaultAction,
      extraProps = _objectWithoutProperties(_ref, ["isIdle", "onConfirm", "onCancel", "timeout", "defaultAction"]); // state value used to determine if the modal should be shown


  var _useState = (0, _react.useState)(isIdle),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1]; // ref used for the setTimeout instance used to logout


  var logoutTimeoutRef = (0, _react.useRef)(null);
  var handleConfirm = (0, _react.useCallback)(function () {
    // clear the timeout if exists
    if (logoutTimeoutRef.current !== null) {
      window.clearTimeout(logoutTimeoutRef.current);
    }

    setIsModalOpen(false);
    onConfirm();
  }, [onConfirm]);
  var handleCancel = (0, _react.useCallback)(function () {
    // clear the timeout
    if (logoutTimeoutRef.current !== null) {
      window.clearTimeout(logoutTimeoutRef.current);
    } // close the modal


    setIsModalOpen(false); // call onCancelLogout prop if exists

    if (onCancel) onCancel();
    setIsModalOpen(false);
  }, [onCancel]);
  (0, _react.useEffect)(function () {
    // if is idle, set a timeout
    if (isIdle) {
      // clear any existing timers
      if (logoutTimeoutRef.current !== null) {
        window.clearTimeout(logoutTimeoutRef.current);
      } // open the modal


      setIsModalOpen(true); // set a new timer that will fire the default action when expires

      if (defaultAction === DEFAULT_ACTION_CONFIRM) {
        logoutTimeoutRef.current = window.setTimeout(handleConfirm, timeout);
      } else {
        logoutTimeoutRef.current = window.setTimeout(handleCancel, timeout);
      }
    }
  }, [isIdle, timeout, defaultAction, handleConfirm, handleCancel]);
  return /*#__PURE__*/_react.default.createElement(_ModalAlert.default, _extends({
    isOpen: isModalOpen,
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    confirmLabel: "Logout",
    cancelLabel: "Stay Logged In",
    heading: "Session is idle...",
    isWarning: true
  }, extraProps), isModalOpen && /*#__PURE__*/_react.default.createElement("p", null, "You will be automatically logged out in ", /*#__PURE__*/_react.default.createElement(_CountDown.default, {
    time: timeout
  }), " seconds."));
};

exports.IdleLogoutModal = IdleLogoutModal;
IdleLogoutModal.propTypes = {
  isIdle: _propTypes.default.bool.isRequired,
  onConfirm: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  timeout: _propTypes.default.number,
  defaultAction: _propTypes.default.oneOfType([_propTypes.default.any, _propTypes.default.any])
};
IdleLogoutModal.displayName = 'IdleLogoutModal';
var _default = IdleLogoutModal;
exports.default = _default;